// generated by genversion
module.exports = '1.1.0'
